module.exports = __webpack_public_path__ + "img/landing-page-image.522552fb.png";